import { Authenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'

const SignMeWithEmailPassword = () => {
  return <Authenticator hideSignUp></Authenticator>
}

export default SignMeWithEmailPassword
